var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "" } },
        [
          _c("v-toolbar-title", [_vm._v("\n      Conversation history\n    ")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-icon",
            {
              on: {
                click: function($event) {
                  return _vm.reloadConversation()
                }
              }
            },
            [_vm._v("refresh")]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.disableForm
        ? _c(
            "v-layout",
            { attrs: { wrap: "", "justify-start": "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md8: "" } },
                [
                  _c("v-textarea", {
                    attrs: { block: "", rows: 2, label: "Type something..." },
                    model: {
                      value: _vm.bidText,
                      callback: function($$v) {
                        _vm.bidText = $$v
                      },
                      expression: "bidText"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "px-1", attrs: { sm12: "", md2: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-1 px-0",
                      attrs: {
                        block: "",
                        loading: _vm.loadingBtn,
                        disabled: _vm.loadingBtn
                      },
                      on: { click: _vm.sendBidMessage }
                    },
                    [_vm._v("\n        Send\n      ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "timeline-section",
          class: {
            "text-md-center text-lg-center text-sm-center pt-4": _vm.loadingData
          }
        },
        [
          _vm.bidTimeline && !_vm.loadingData
            ? _c("timeline", { attrs: { "timeline-object": _vm.bidTimeline } })
            : _vm._e(),
          _vm._v(" "),
          _vm.loadingData
            ? _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9d157c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9d157c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BidConversation.vue
// module id = null
// module chunks = 